import { FunctionComponent } from 'react'
import { Dropdown } from 'react-bootstrap'

import Avatar from 'components/ui/avatar'
import Icon from 'components/ui/icon'
import sidebarCss from './sidebar.module.scss'

type ProfileMenuProps = {
  name: string | null
  email: string | null
  onOpenAccount: () => void
  onLogout: () => void
}

/** User card at the bottom of the sidebar; opens the account menu upwards. */
const ProfileMenu: FunctionComponent<ProfileMenuProps> = ({
  name,
  email,
  onOpenAccount,
  onLogout,
}) => (
  <Dropdown drop="up">
    <Dropdown.Toggle
      as="button"
      type="button"
      className={`${sidebarCss.profileToggle} dropdown-toggle-no-caret`}
      aria-label="Perfil do usuário"
    >
      <Avatar name={name || email} />
      <span className={sidebarCss.profileText}>
        <span className={sidebarCss.profileName}>{name || email}</span>
        {name && <span className={sidebarCss.profileEmail}>{email}</span>}
      </span>
    </Dropdown.Toggle>

    <Dropdown.Menu className={sidebarCss.profileMenu}>
      <Dropdown.Item as="button" type="button" onClick={onOpenAccount}>
        <Icon name="user" />
        Minha conta
      </Dropdown.Item>
      <Dropdown.Item as="button" type="button" onClick={onLogout}>
        <Icon name="logout" />
        Sair
      </Dropdown.Item>
    </Dropdown.Menu>
  </Dropdown>
)

export default ProfileMenu
